import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { CalculatorStepItem } from 'site-modules/calculators/components/calculator-step-item/calculator-step-item';
import { CalculatorRowItem } from 'site-modules/calculators/components/calculator-row-item/calculator-row-item';
import { PaymentInput } from 'site-modules/shared/components/calculator/payment-input/payment-input';
import { PAYMENT_INPUT_PROPS } from 'site-modules/calculators/constants/calculators';
import { VehicleSelectorView } from 'site-modules/calculators/components/vehicle-selector-view/vehicle-selector-view';
import { VehicleSelectorDrawer } from 'site-modules/shared/components/vehicle-selector/vehicle-selector-drawer';

export const GasGuzzlerNewFuelEfficientVehicleStep = ({
  mpg,
  price,
  style = null,
  onKeyPress,
  onInputChange,
  onVehicleUpdate,
  onRemoveStyle,
}) => {
  const [isVehicleSelectorDrawerOpen, setIsVehicleSelectorDrawerOpen] = useState(false);

  const toggleVehicleSelectorDrawer = useCallback(() => {
    setIsVehicleSelectorDrawerOpen(state => !state);
  }, []);

  return (
    <CalculatorStepItem stepName="Select a New Fuel-Efficient Vehicle">
      {!style ? (
        <CalculatorRowItem title="">
          <Button
            onClick={toggleVehicleSelectorDrawer}
            size="sm"
            color="outline-primary-b"
            className="text-transform-none"
            data-test="vehicle-lookup"
          >
            Select a vehicle
          </Button>
        </CalculatorRowItem>
      ) : null}
      <VehicleSelectorView style={style} onChange={toggleVehicleSelectorDrawer} onDelete={onRemoveStyle} />
      <CalculatorRowItem title="Fuel-Efficient Vehicle Sales Price">
        <PaymentInput
          name="vehicleSalesPrice"
          key={price}
          value={price}
          onKeyPress={onKeyPress}
          onBlur={onInputChange}
          isCurrency
          {...PAYMENT_INPUT_PROPS}
          inputAriaLabel="Fuel-Efficient Vehicle Sales Price"
        />
      </CalculatorRowItem>
      <CalculatorRowItem title="MPG for the fuel-efficient vehicle">
        <PaymentInput
          name="mpg"
          key={mpg}
          value={mpg}
          onKeyPress={onKeyPress}
          onBlur={onInputChange}
          {...PAYMENT_INPUT_PROPS}
          inputAriaLabel="MPG for the fuel-efficient vehicle"
        />
      </CalculatorRowItem>
      <VehicleSelectorDrawer
        isOpen={isVehicleSelectorDrawerOpen}
        onToggle={toggleVehicleSelectorDrawer}
        onSave={onVehicleUpdate}
        isMpgField
      />
    </CalculatorStepItem>
  );
};

GasGuzzlerNewFuelEfficientVehicleStep.propTypes = {
  mpg: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  style: PropTypes.shape({
    makeName: PropTypes.string,
    modelName: PropTypes.string,
    year: PropTypes.number,
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  onKeyPress: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onVehicleUpdate: PropTypes.func.isRequired,
  onRemoveStyle: PropTypes.func.isRequired,
};
